import React from "react";
import SignUpForm from "./SignUpForm";

const SignUpSection = () => {
  return (
    <div className="log-in sign-block">
      <div className="title">Create New Account</div>
      <div className="sub-title">Please create account first before enjoy the features.</div>
      <SignUpForm />
    </div>
  );
};

export default SignUpSection;
